import React from "react";
import {
  OrganisationMemberSelect,
  OrganisationMemberSelectProps,
} from "../OrganisationMemberSelect.js";
import { useField } from "formik";

interface Props
  extends Omit<OrganisationMemberSelectProps, "value" | "onChange"> {
  name: string;
  value?: string | null;
  onChange?: (value: string | null) => void;
  onChanged?: () => void | Promise<void>;
}

export const OrganisationMemberField = ({
  name,
  value: valueProp,
  onChange: onChangeProp,
  onChanged,
  ...props
}: Props) => {
  const [{ value }, { touched, error }, { setValue }] = useField<string | null>(
    name
  );

  return (
    <OrganisationMemberSelect
      value={valueProp !== undefined ? valueProp : value}
      onChange={
        onChangeProp ??
        (async value => {
          await setValue(value);
          onChanged?.();
        })
      }
      {...props}
      error={props.error ?? (touched ? error : undefined)}
    />
  );
};
